import func from '@/plugins/function';

export default {
  setContract(state, { contract, then }) {
    state.contract = contract;

    func.execFunc(then);
  },
};
